/* eslint-disable */

export const testBasic = value => {
	const regex = RegExp(/^.{1,100}$/)
	return regex.test(value)
}

export const testEmail = email => {
	const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
	return regex.test(email)
}

export const testPassword = password => {
	//Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:
	//(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$

	//Minimum eight characters, at least one uppercase letter, one lowercase letter and one number, and accepts special characters
	//^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$
	const regex = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@$?_-]{8,}$/)
	return regex.test(password)
}

export const testName = name => {
	const regex = RegExp(
		/^[A-Za-z-\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]{2,30}$/
	)
	return regex.test(name)
}

export const testPhoneNumber = phonenumber => {
	const regex = RegExp(/^[0-9- ]{1,30}$/)
	return regex.test(phonenumber)
}

export const testPrefix = prefix => {
	const regex = RegExp(/^[+\d]{1,5}$/)
	return regex.test(prefix)
}

export const testAddress = address => {
	const regex = RegExp(
		/^[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s0-9]{5,60}$/
	)
	return regex.test(address)
}

export const testBirthdate = birthdate => {
	const regex = RegExp(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/)
	return regex.test(birthdate)
}
export const testLength = length => {
	const regex = RegExp(/^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|300)$/)
	return regex.test(length)
}
export const testWeight = weight => {
	const regex = RegExp(/^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|300)$/)
	return regex.test(weight)
}
export const testShoeSize = shoeSize => {
	const regex = RegExp(/^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|300)$/)
	return regex.test(shoeSize)
}

export const testImage = image => {
	const regex = RegExp(/^(?!\s*$).+/)
	return regex.test(image)
}

// All the validation data used when validating form inputs
export const validationErrors = {
	email: {
		error: false,
		message: ''
	},
	emailconfirm: {
		error: false,
		message: ''
	},
	password: {
		error: false,
		message: ''
	},
	name: {
		error: false,
		message: ''
	},
	lastname: {
		error: false,
		message: ''
	},
	address: {
		error: false,
		message: ''
	},
	zipcode: {
		error: false,
		message: ''
	},
	city: {
		error: false,
		message: ''
	},
	mobilephoneprefix: {
		error: false,
		message: ''
	},
	mobilephone: {
		error: false,
		message: ''
	},
	birthdate: {
		error: false,
		message: ''
	},
	length: {
		error: false,
		message: ''
	},
	weight: {
		error: false,
		message: ''
	},
	shoeSize: {
		error: false,
		message: ''
	},
	consent: {
		error: false,
		message: ''
	},
	passwordOld: {
		error: false,
		message: ''
	},
	passwordNew: {
		error: false,
		message: ''
	},
	image: {
		error: false,
		message: ''
	}
}
